// src/pages/BlogDetail.jsx
import { useParams } from "react-router-dom";
import { blogPosts } from "../../utils/blogData";
import { Helmet } from "react-helmet-async";
import { useRef } from "react";
// import FindBestTransferRates from "../about/FindBestTransferRates";
import FormTransferHotspot from '../transfer-hotspot/FormTransferHotspot';

const BlogDetail = ({getPost}) => { // changed done by me , added props: getPost
  const displayFormRef = useRef(false);
  const { id } = useParams();
  const post = getPost.find((p) => p.id === id);
  console.log(post);
  const blogsIndex = blogPosts.findIndex(p => post.id === p.id);
  if (!post) return <p className="p-6">Blog not found</p>;
  const meta = post.meta || {};
  return (

    <>
      <Helmet>
          <title>{meta.title}</title>
          <meta name="description" content={meta.description} />
          <meta name="keywords" content={meta.keywords} />
            {meta.url && (
                <link rel="canonical" href={meta.url} />
            )}
      </Helmet>
      {blogsIndex === -1 ? <FormTransferHotspot/> : null}
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12 space-y-8 mt-16">
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold">
          {post.title}
        </h1>
        {post.desc && (
          <p className="text-base sm:text-lg text-gray-700">{post.desc}</p>
        )}
        {Array.isArray(post.sections) &&
          post.sections.map((section, i) => (
            <div key={i} className="space-y-4">
              {section.heading && (
                <h2 className="text-2xl sm:text-3xl font-semibold">
                  {section.heading}
                </h2>
              )}

              {/* Content Paragraphs */}
              {Array.isArray(section.content)
                ? section.content.map((para, j) => (
                    <p key={j} className="text-gray-700 text-base sm:text-lg">
                      {para}
                    </p>
                  ))
                : section.content && (
                    <p className="text-gray-700 text-base sm:text-lg">
                      {section.content}
                    </p>
                  )}

              {/* Lists */}
              {Array.isArray(section.list) &&
                section.list.map((item, k) => (
                  <div key={k}>
                    <h3 className="font-medium mt-4 text-xl sm:text-2xl">
                      {item.title}
                    </h3>
                    <ul className="list-disc list-inside text-gray-600 text-base sm:text-lg">
                      {Array.isArray(item.points) &&
                        item.points.map((pt, l) => <li key={l}>{pt}</li>)}
                    </ul>
                  </div>
                ))}
              
              {/* Tables */}
              {section.table && (
                <div className="overflow-x-auto">
                  <table className="w-full table-auto border mt-2">
                    <thead>
                      <tr className="bg-gray-200">
                        {Array.isArray(section.table.columns) &&
                          section.table.columns.map((col, idx) => (
                            <th
                              key={idx}
                              className="border px-2 py-2 text-left text-base sm:text-lg font-semibold"
                            >
                              {col}
                            </th>
                          ))}
                      </tr>
                    </thead>
                    <tbody>
                      {Array.isArray(section.table.rows) &&
                        section.table.rows.map((row, ridx) => (
                          <tr key={ridx} className="even:bg-gray-50">
                            {Array.isArray(row) &&
                              row.map((cell, cidx) => (
                                <td
                                  key={cidx}
                                  className="border px-2 py-2 text-sm sm:text-base"
                                >
                                  {cell}
                                </td>
                              ))}
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          ))}
      </div>
    </>
    
  );
};

export default BlogDetail;


